import { motion } from "framer-motion";
import { useTour } from "@/context/TourContext";
import { useTourTargetRect } from "@/lib/useTourTargetRect";

// Module-level constants (not recreated every render) — mirrors the same
// pattern used in DailyBriefCard.js so framer-motion never receives a
// fresh object literal on every re-render.
const SPOTLIGHT_MOTION_INITIAL = { opacity: 0 };
const SPOTLIGHT_MOTION_ANIMATE = { opacity: 1 };
const SPOTLIGHT_MOTION_TRANSITION = { duration: 0.2 };

/**
 * v1.3 Presentation Mode polish — dims the whole app and cuts a
 * highlight "window" around the active tour step's target element.
 * See `useTourTargetRect` for the shared measurement logic (kept in
 * sync with `TourStepPopover` so the highlight and callout never
 * disagree about where the target is).
 */
export const TourSpotlightOverlay = () => {
  const { activeStep } = useTour();
  const rect = useTourTargetRect(activeStep?.targetTestId);

  if (!activeStep) return null;

  return (
    <div className="fixed inset-0 z-[150]" data-testid="tour-spotlight-overlay" aria-hidden="true">
      {rect ? (
        <motion.div
          initial={SPOTLIGHT_MOTION_INITIAL}
          animate={SPOTLIGHT_MOTION_ANIMATE}
          transition={SPOTLIGHT_MOTION_TRANSITION}
          className="absolute rounded-xl ring-2 ring-[hsl(var(--role-accent))] ring-offset-2 ring-offset-transparent"
          style={{
            top: rect.top, left: rect.left, width: rect.width, height: rect.height,
            boxShadow: "0 0 0 9999px rgba(0,0,0,0.55)",
          }}
        />
      ) : (
        <div className="absolute inset-0 bg-black/55" />
      )}
    </div>
  );
};
